export const SOURCE_BRANCH = process.env.REACT_APP_BRANCH || 'local';
